<template>
  <v-card class="pa-6" elevation="2" style="background: #f5f6fa;">
    <div class="d-flex justify-space-between align-center mb-2">
      <div class="font-weight-bold" style="font-size: 1.3em;">Detalhes do atendimento</div>
      <v-btn icon @click="$emit('fechar')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
    <v-row>
      <v-col cols="12">
        <v-card flat class="pa-4" style="background: white; border-radius: 16px;">
          <div class="font-weight-bold mb-3" style="font-size: 1.1em;">Informações do Atendimento</div>
          <div class="mb-2"><strong>Data e Horário:</strong> {{ formatarDataHora(atendimento.data_hora) }}</div>
          <div class="mb-2"><strong>Especialidade:</strong> {{ atendimento.especialidade.nome }}</div>
          <div class="mb-2"><strong>Status:</strong> <v-chip :color="atendimento.statusColor" dark small>{{ atendimento.statusTexto }}</v-chip></div>
          <div class="mb-2 d-flex align-center">
            <v-icon left color="grey" class="mr-1">mdi-map-marker</v-icon>
            <span class="font-weight-bold mr-1">Local de atendimento:</span>
            <span class="caption">{{ atendimento.local_atendimento || '-' }}</span>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" md="6" v-if="atendimento.paciente">
        <v-card flat class="pa-4 mb-4" style="background: white; border-radius: 16px;">
          <div class="font-weight-bold mb-3" style="font-size: 1.1em;">Informações do Paciente</div>
          <div class="mb-2"><strong>Nome:</strong> {{ atendimento.paciente.pessoa.nome }} {{ atendimento.paciente.pessoa.sobrenome }}</div>
          <div class="mb-2"><strong>CPF:</strong> {{ atendimento.paciente.pessoa.cpf }}</div>
          <div class="mb-2"><strong>Nota do Paciente:</strong>
            <v-chip color="amber lighten-3" small>
              <v-icon color="amber" small left>mdi-star</v-icon>
              {{ atendimento.paciente.nota_paciente || '-' }}
            </v-chip>
          </div>
          <div class="mb-2"><strong>Uso de Remédio Contínuo:</strong> {{ atendimento.paciente.uso_remedio_continuo }}</div>
          <div class="mb-2"><strong>doenças preexistentes:</strong> {{ atendimento.paciente.observacoes_medicas || '-' }}</div>
          <div class="mb-2 d-flex align-center">
            <v-icon left color="green" class="mr-1">mdi-phone</v-icon>
            <span class="font-weight-bold mr-1">Telefone:</span>
            <span>{{ atendimento.paciente.pessoa.telefone || '-' }}</span>
          </div>
          <div class="mb-2 d-flex align-center">
            <v-icon left color="blue" class="mr-1">mdi-email</v-icon>
            <span class="font-weight-bold mr-1">Email:</span>
            <span>{{ atendimento.paciente.pessoa.email || '-' }}</span>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" md="6" v-if="atendimento.fisioterapeuta">
        <v-card flat class="pa-4 mb-4" style="background: white; border-radius: 16px;">
          <div class="font-weight-bold mb-3" style="font-size: 1.1em;">Informações do Fisioterapeuta</div>
          <div class="mb-2"><strong>Nome:</strong> {{ atendimento.fisioterapeuta.pessoa.nome }} {{ atendimento.fisioterapeuta.pessoa.sobrenome }}</div>
          <div class="mb-2"><strong>CREFITO:</strong> {{ atendimento.fisioterapeuta.crefito || '-' }}</div>
          <div class="mb-2"><strong>Nota do Fisioterapeuta:</strong>
            <v-chip color="amber lighten-3" small>
              <v-icon color="amber" small left>mdi-star</v-icon>
              {{ atendimento.fisioterapeuta.nota_fisioterapeuta || '-' }}
            </v-chip>
          </div>
          <div class="mb-2"><strong>Valor do Atendimento:</strong> R$ {{ atendimento.fisioterapeuta.valor_atendimento || '-' }}</div>
          <div class="mb-2 d-flex align-center">
            <v-icon left color="green" class="mr-1">mdi-phone</v-icon>
            <span class="font-weight-bold mr-1">Telefone:</span>
            <span>{{ atendimento.fisioterapeuta.pessoa.telefone || '-' }}</span>
          </div>
          <div class="mb-2 d-flex align-center">
            <v-icon left color="blue" class="mr-1">mdi-email</v-icon>
            <span class="font-weight-bold mr-1">Email:</span>
            <span>{{ atendimento.fisioterapeuta.pessoa.email || '-' }}</span>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="mt-2 mb-2" align="center" justify="end">
      <v-btn color="primary" text @click="$emit('fechar')">Fechar</v-btn>
    </v-row>
  </v-card>
</template>

<script>
export default {
  props: {
    atendimento: Object
  },
  methods: {
    formatarDataHora(iso) {
      if (!iso) return ''
      const [data, hora] = iso.split('T')
      return `${data.split('-').reverse().join('/')} às ${hora.slice(0,5)}`
    }
  }
}
</script>
